export enum PAYMENT_FLOW {
  manual = 'manual',
  integrated = 'integrated',
  noConnection = 'no-connection'
}
